import React, { Component } from 'react'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'
import * as R from 'ramda'

import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'

import dataActions from 'actions/dataActions'

let select = (state) => state

export class FormFooter extends Component{
	render(){
		let { props } =this
		let mode = props.mode
		return(
			<div
				className="handleButtons"
				style={{
					width:"100%"
				  , height:"41px"
				  , paddingTop: "3px"
				  , borderTop: "1px solid #f0f0f0"
				  , backgroundColor: "white"
				  , display: "flex"
				  , justifyContent: "flex-end"
				  , float: "right"
				  , borderRadius: "2px 0 0 2px"
				  , boxShadow:"-1px -1px 1px rgba(0,0,0,0.2)"
				}}
			>
					<FlatButton
				        label="Delete"
						disabled = {props.deleteDisabled}
				        onClick={()=>{
				            props.DELETE()
				        }}
				        primary={true}
				        style={{
				            height: "35px"
				          , borderRadius: "4px"
				          , width: "95px"
				          , color: props.deleteDisabled?"rgb(190, 190, 190)":"red"
						  , marginLeft: "5px"
				        }}
				    />
				    <FlatButton
				        label="Cancel"
				        primary={true}
				        onClick={()=>{
							if( mode == "creating" || mode == "new" ){
								props.DELETE_YES(props.objectID)
								props.goBack()
				            }else{
								 props.ROLLBACK()
							}
				        }}
				        style={{
				            height: "35px"
				          , borderRadius: "4px"
				          , width: "95px"
						  , marginLeft: "5px"
				        }}
				        disabled={mode == "view"}
				    />
				    <FlatButton
				        label={(mode=="new" || mode=="creating")?"Create":(mode=="edit")?"Save":"Close"}
						primary={true}
				        onClick={()=>{
							if( mode == "view" ){
								if (props.masterDetail) props.CLOSE()
								else props.goBack()
				            }
							if( mode == "creating" || mode == "edit" || mode == "new" ){
								props.COMMIT()
				            }

				        }}
						disabled={props.commitDisabled}
						style={{
				            height: "35px"
				          , borderRadius: "4px"
				          , width: "95px"
						  , marginLeft: "5px"
				        }}
				    />
			</div>
		)
	}
}

export default connect(select, R.mergeAll([dataActions, routerActions]))(FormFooter)



// WEBPACK FOOTER //
// ./src/components/FormFooter.js